import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import { footerHeight, headerHeight, MainContainer } from '../../theme'
import Error from '../Error'

export function OnboardingViewSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div className="text-center p-2">
      <div className="mt-5">
        <Skeleton height={50} width={'100%'} />
      </div>
      <div className="mt-5">
        <Skeleton height={250} />
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Skeleton height={120} width={120} />
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Skeleton height={50} width={100} />
      </div>
    </div>
  )
}

export function OtpPhoneViewSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div className="text-center p-2">
      <div className="mt-5">
        <Skeleton height={50} width={'100%'} />
      </div>
      <div className="mt-5">
        <Skeleton height={250} />
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Skeleton height={120} width={120} />
      </div>
      <div className="d-flex justify-content-center mt-3">
        <Skeleton height={50} width={100} />
      </div>
    </div>
  )
}

export function LegalViewSkeletons(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div className="text-center p-2">
      <Skeleton count={1} height={38} width={300} />
      <div className="mt-2">
        <Skeleton count={1} height={2} />
      </div>
      <Skeleton height={330} />
    </div>
  )
}

export function OtpViewSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div style={{ paddingTop: '16px' }} className="text-center p-3">
      <div className="d-flex justify-content-center">
        <Skeleton height={30} width={150} />
      </div>
      <div className="mt-4">
        <Skeleton height={250} width={250} />
      </div>
      <div className="mt-3">
        <Skeleton height={30} width={250} />
      </div>
      <div className="mt-3">
        <Skeleton height={30} width={120} />
      </div>
      <div className="d-flex justify-content-center mt-3">
        <div className="mr-3">
          <Skeleton height={45} width={40} />
        </div>
        <div className="mr-3">
          <Skeleton height={45} width={40} />
        </div>
        <div className="mr-3">
          <Skeleton height={45} width={40} />
        </div>
        <div className="mr-3">
          <Skeleton height={45} width={40} />
        </div>
      </div>
      <div className="mt-2">
        <Skeleton height={50} width={150} />
      </div>
      <div className="mt-2">
        <Skeleton height={30} width={150} />
      </div>
      <div className="mt-2">
        <Skeleton height={30} width={80} />
      </div>
      {/* <Skeleton circle={true} height={120} width={120} />
      
      <div className="mt-1">
        <Skeleton height={30} width={120} />
      </div>

      <div className="mt-1">
        <Skeleton height={20} width={120} />
      </div>

      <div className="my-4">
        <Skeleton height={35} width={150} />
      </div>

      <div className="mt-3">
        <Skeleton count={1} height={2} width={200} />
      </div>

      <div>
        <Skeleton height={50} />
      </div>

      <div className="mt-3">
        <Skeleton count={1} height={15} width={80} />
      </div>
      <div>
        <Skeleton count={1} height={10} width={60} />
      </div> */}
    </div>
  )
}

export function HomePageSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <MainContainer>
        <MainContainer>
          <Skeleton height={230} width={'100%'} />
        </MainContainer>
        <div className="mx-3">
          <Skeleton height={80} width={'100%'} />
        </div>
        <div className="mt-3">
          <Skeleton height={40} width={200} />
        </div>
        <div className="row mt-3">
          <div className="col-4 ">
            <Skeleton height={87} width={87} />
          </div>
          <div className="col-4">
            <Skeleton height={87} width={87} />
          </div>
          <div className="col-4 ">
            <Skeleton height={87} width={87} />
          </div>
        </div>
        <div className="mt-1">
          <Skeleton height={40} width={'100%'} />
        </div>
        <div>
          <Skeleton height={40} width={'100%'} />
        </div>
        <div>
          <Skeleton height={40} width={'100%'} />
        </div>
        <div>
          <Skeleton height={40} width={'100%'} />
        </div>
        <div>
          <Skeleton height={40} width={'100%'} />
        </div>
        <div>
          <Skeleton height={40} width={'100%'} />
        </div>
      </MainContainer>
      {/* <Skeleton height={200} />
      <div className="mt-4">
        <Skeleton count={1} height={24} width={128} />
      </div>
      <Row className="mt-2">
        <Col>
          <Skeleton height={120} />
        </Col>
        <Col>
          <Skeleton height={120} />
        </Col>
      </Row>
      <div className="mt-4">
        <Skeleton count={1} height={24} width={128} />
      </div>
      <Row className="mt-2">
        <Col>
          <Skeleton height={160} />
        </Col>
        <Col>
          <Skeleton height={160} />
        </Col>
      </Row> */}
    </>
  )
}

export function VideoListSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div>
        <Skeleton height={50} />
      </div>
      <div className="mt-2">
        <Skeleton height={50} />
      </div>
      <MainContainer>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gridGap: '10px',
          }}
        >
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
        </div>
      </MainContainer>
    </>
  )
}

export function VideoSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <MainContainer>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gridGap: '10px',
          }}
        >
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
        </div>
      </MainContainer>
    </>
  )
}

export function AppListSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="mb-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <Skeleton height={240} />
      <div className="mt-2 mb-2">
        <Skeleton count={2} height={10} />
      </div>
      <Skeleton height={60} />
      <div className="mt-4 mb-4">
        <Skeleton height={24} width={150} count={1} />
      </div>
      <Skeleton height={90} count={1} />
      <Skeleton height={90} count={1} />
      <Skeleton height={90} count={1} />
    </>
  )
}

export function JourneyViewSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="mt-3 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>

      <div className="mt-3">
        <Skeleton height={2} />
      </div>

      <div className="text-center">
        <Skeleton circle={true} height={80} width={80} />{' '}
        <Skeleton circle={true} height={80} width={80} />{' '}
        <Skeleton circle={true} height={80} width={80} />{' '}
      </div>

      <div
        className="mt-2 mb-2"
        style={{
          height: `calc(100vh - ${headerHeight + footerHeight + 180}px)`,
        }}
      >
        <Skeleton height="100%" />
      </div>
      <div className="mt-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <div className="text-center mt-2">
        <Skeleton circle={true} height={40} width={40} />{' '}
        <Skeleton circle={true} height={40} width={40} />
      </div>
    </>
  )
}

export function QuizSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <MainContainer>
        <div className="mb-4 pr-4 pl-4">
          <Skeleton height={24} count={1} />
        </div>
        <Skeleton height={24} count={2} />
        <div className="mt-4 mb-4">
          <Skeleton height={80} count={1} />
          <Skeleton height={80} count={1} />
          <Skeleton height={80} count={1} />
          <Skeleton height={80} count={1} />
        </div>
      </MainContainer>
    </>
  )
}

export function ResultCardSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="text-center mt-4 pt-4 mb-4">
        <div className="mb-4">
          <Skeleton circle={true} height={150} width={150} />{' '}
        </div>
        <div className="mb-4 mr-4 ml-4">
          <Skeleton height={36} count={1} />
        </div>
        <div className="mb-4 mr-4 ml-4">
          <Skeleton height={24} count={2} />
        </div>
        <Skeleton height={60} count={1} />
        <div className="mt-4 mb-4 pr-4 pl-4">
          <Skeleton height={24} count={1} />
        </div>
        <div className="text-center mt-2">
          <Skeleton circle={true} height={40} width={40} />{' '}
          <Skeleton circle={true} height={40} width={40} />
        </div>
      </div>
    </>
  )
}

export function LeaderboardSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="mb-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <div className="mt-4 mb-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <div className="text-center mt-2">
        <Skeleton circle={true} height={40} width={40} />{' '}
        <Skeleton circle={true} height={40} width={40} />
      </div>
    </>
  )
}

export function ProfileSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="mb-2">
        <Skeleton height={24} width={150} count={1} />
      </div>
      <Skeleton height={160} count={1} />
      <div className="mt-4 mb-2">
        <Skeleton height={24} width={150} count={1} />
      </div>
      <Skeleton height={160} count={1} />
      <div className="mt-4 mb-4">
        <Skeleton height={60} count={1} />
      </div>
      <Row>
        <Col>
          <Skeleton height={60} count={1} />
        </Col>
        <Col>
          <Skeleton height={60} count={1} />
        </Col>
      </Row>
    </>
  )
}

export function FAQViewSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <>
      <div className="mb-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <Skeleton height={60} count={1} />
      <div className="mt-4 mb-4 pr-4 pl-4">
        <Skeleton height={24} count={1} />
      </div>
      <div className="text-center mt-2">
        <Skeleton circle={true} height={40} width={40} />{' '}
        <Skeleton circle={true} height={40} width={40} />
      </div>
    </>
  )
}

export function JourneyMapSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div style={{ height: '400px' }}>
      <Skeleton circle={true} height={54} width={54} />
      <div>
        <Skeleton height={60} count={1} width={2} />
      </div>
      <Skeleton circle={true} height={54} width={54} />
      <div>
        <Skeleton height={60} count={1} width={2} />
      </div>
      <Skeleton circle={true} height={54} width={54} />
    </div>
  )
}

export function WorksheetSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div>
      <div>
        <Skeleton height={50} />
      </div>
      <div className="mt-2">
        <Skeleton height={50} />
      </div>
      <MainContainer>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gridGap: '10px',
          }}
        >
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
          <div>
            <Skeleton height={120} />
          </div>
        </div>
      </MainContainer>
    </div>
  )
}

export function FamilySkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <MainContainer>
      <div className="mt-3">
        <Skeleton height={170} />
      </div>

      <div className="mt-3">
        <Skeleton height={250} />
      </div>

      <div className="mt-3">
        <Skeleton height={250} />
      </div>
    </MainContainer>
  )
}

export function BonusActivity(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <MainContainer>
      <div className="mt-2">
        <Skeleton height={50} />
      </div>

      <div className="mt-2">
        <Skeleton height={50} />
      </div>

      <div className="mt-2">
        <Skeleton height={50} />
      </div>
      <div className="mt-2">
        <Skeleton height={50} />
      </div>

      <div className="mt-2">
        <Skeleton height={50} />
      </div>

      <div className="mt-2">
        <Skeleton height={50} />
      </div>
    </MainContainer>
  )
}

export function TopParentSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <div style={{ textAlign: 'center' }}>
      <div className="mt-3">
        <Skeleton circle={true} height={70} width={70} />
      </div>
      <div className="mt-3 d-flex justify-content-around">
        <Skeleton circle={true} height={70} width={70} />
        <Skeleton circle={true} height={70} width={70} />
      </div>
      <div className="mt-3 mt-3 d-flex justify-content-around">
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
      </div>
      <div className="mt-3 mt-3 d-flex justify-content-around">
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
      </div>

      <div className="mt-3 mt-3 d-flex justify-content-around">
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
        <Skeleton className="mx-2" circle={true} height={70} width={70} />
      </div>
    </div>
  )
}

export function AwardScreen(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <MainContainer>
      <Skeleton className="mx-2" height={200} width={'100%'} />
      <div className="my-2">
        <Skeleton className="mx-2" height={50} width={'100%'} />
      </div>
      <div className="my-2">
        <Skeleton className="mx-2" height={50} width={'100%'} />
      </div>
      <div className="my-2">
        <Skeleton className="mx-2" height={50} width={'100%'} />
      </div>
      <div className="my-2">
        <Skeleton className="mx-2" height={50} width={'100%'} />
      </div>
      <div className="my-2">
        <Skeleton className="mx-2" height={50} width={'100%'} />
      </div>
    </MainContainer>
  )
}

export function CertificateSkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return <MainContainer></MainContainer>
}

export function HomepageExtraActivitySkeleton(props) {
  if (props.error || props.timedOut) return <Error refetch={props.retry} />
  return (
    <MainContainer>
      <div>
        <Skeleton className="mx-2" height={82} width={360} />
      </div>
    </MainContainer>
  )
}

export function BannerSkeleton() {
  return (
    <MainContainer>
      <div>
        <Skeleton height={300} width={320} />
      </div>
    </MainContainer>
  )
}
